
import {FC} from "react";

import React from 'react';

import PPAPDemandForm from "../../forms/ppap/ppap-demand-form";

interface Interface{
    requestId: any;
    mode?: "View" | "Add new";
}

const PPAPDemandScreen: FC<Interface> = (props:any) => {

    

    return (
            
                <PPAPDemandForm
                    requestId={props.requestId}
                    mode={props.mode}
                />
            
    );
}
export default PPAPDemandScreen;
